import Bugsnag from '@bugsnag/js'

import { UPDATE_APP_DATA } from 'constants/action_types'
import {
  SAVE_CANNED_REPLY_TEMPLATE_SUCCESS,
  FETCH_CANNED_REPLIES_SUCCESS,
} from 'ducks/cannedReplies/types'
import {
  UPDATE_CARD_STARTED,
  UPDATE_CARD_SUCCESS,
  UPDATE_CARD_FAILED,
  START_TRIAL_STARTED,
  START_TRIAL_SUCCESS,
  UPDATE_SUBSCRIPTION_STARTED,
  UPDATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_FAILED,
  CANCEL_SUBSCRIPTION_STARTED,
  CANCEL_SUBSCRIPTION_SUCCESS,
  FETCH_BILLING_DATA_REQUEST,
  FETCH_BILLING_DATA_SUCCESS,
  FETCH_BILLING_DATA_FAIL,
  APP_BILLING_EXPIRED,
  FETCH_BILLING_INVOICES_REQUEST,
  FETCH_BILLING_INVOICES_SUCCESS,
  FETCH_BILLING_INVOICES_FAIL,
  FETCH_BILLING_INFORMATION_REQUEST,
  FETCH_BILLING_INFORMATION_SUCCESS,
  FETCH_BILLING_INFORMATION_FAILED,
  UPDATE_BILLING_INFORMATION_SUCCESS,
  UPDATE_BILLING_INFORMATION_FAILED,
  CLOSE_CARD_FAILURE_MODAL,
  FETCH_BILLING_SUCCESS,
} from './types'

const reducers = {}

reducers[UPDATE_APP_DATA] = (state, action) => {
  const data = action.data
  const { billing, creditCards, plans } = data

  // Expired billing updates might not send billing, so just
  // check if the object is present before adding it
  // to the state
  if (billing) {
    return {
      ...state,
      ...billing,
      ...{
        cards: creditCards,
        isLoading: false,
        isLoaded: true,
        plans,
      },
    }
  }
  return state
}

reducers[FETCH_BILLING_SUCCESS] = reducers[UPDATE_APP_DATA]

// Share reducer for app_data and expired billing updates
reducers[APP_BILLING_EXPIRED] = reducers[UPDATE_APP_DATA]

reducers[FETCH_BILLING_DATA_REQUEST] = state => {
  return {
    ...state,
    isLoading: true,
  }
}

reducers[FETCH_BILLING_DATA_SUCCESS] = (state, action) => {
  const data = action.payload
  const { billing, creditCards } = data

  return {
    ...state,
    ...billing,
    ...{
      cards: creditCards,
      isLoading: false,
      isLoaded: true,
    },
  }
}

reducers[FETCH_BILLING_DATA_FAIL] = (state, action) => {
  return {
    ...state,
    isLoading: false,
    billingDataError: action.payload.error,
  }
}

reducers[UPDATE_CARD_STARTED] = state => {
  return {
    ...state,
    isUpdatingCard: true,
    hasError: false,
    updateCardError: null,
  }
}

reducers[UPDATE_CARD_SUCCESS] = (state, action) => {
  const data = action.payload

  return {
    ...state,
    isUpdatingCard: false,
    ...{
      cards: data.replaceCard,
    },
  }
}

reducers[UPDATE_CARD_FAILED] = (state, action) => {
  try {
    Bugsnag.notify(new Error('Update Card Failed'), event => {
      event.addMetadata('metaData', {
        cardError: action.payload.error,
      })
    })
  } catch (e) {
    // pass
  }
  return {
    ...state,
    isUpdatingCard: false,
    hasError: true,
    updateCardError: action.payload.error,
    showCardErrorModal: true,
  }
}

reducers[START_TRIAL_STARTED] = (state, action) => {
  const billing = action.payload

  return {
    ...state,
    ...{
      ...billing,
      isStartingTrial: true,
    },
  }
}

reducers[START_TRIAL_SUCCESS] = (state, action) => {
  const billing = action.payload

  return {
    ...state,
    ...{
      ...billing,
      isStartingTrial: false,
    },
  }
}

reducers[UPDATE_SUBSCRIPTION_STARTED] = state => {
  return {
    ...state,
    ...{
      isSaving: true,
      updateSubscriptionError: null,
    },
  }
}

reducers[UPDATE_SUBSCRIPTION_SUCCESS] = (state, action) => {
  const data = action.payload
  const { updateSubscription } = data
  return {
    ...state,
    ...updateSubscription,
    ...{
      isSaving: false,
    },
  }
}

reducers[UPDATE_SUBSCRIPTION_FAILED] = (state, action) => {
  return {
    ...state,
    isSaving: false,
    updateSubscriptionError: action.payload.error,
  }
}

reducers[CANCEL_SUBSCRIPTION_STARTED] = state => {
  return {
    ...state,
    ...{
      isCanceling: true,
    },
  }
}

reducers[CANCEL_SUBSCRIPTION_SUCCESS] = (state, action) => {
  const data = action.payload
  const { cancelSubscription } = data
  return {
    ...state,
    ...cancelSubscription,
    ...{
      isCanceling: false,
    },
  }
}

reducers[FETCH_BILLING_INVOICES_REQUEST] = state => {
  return {
    ...state,
    invoices: {
      isLoading: true,
      hasError: false,
    },
  }
}

reducers[FETCH_BILLING_INVOICES_SUCCESS] = (state, action) => {
  const data = action.payload.data
  const { invoices } = data

  return {
    ...state,
    invoices: {
      isLoading: false,
      isLoaded: true,
      data: invoices,
    },
  }
}

reducers[FETCH_BILLING_INVOICES_FAIL] = (state, action) => {
  const error = action.payload.error

  return {
    ...state,
    invoices: {
      isLoading: false,
      hasError: true,
      error,
    },
  }
}

reducers[FETCH_BILLING_INFORMATION_REQUEST] = state => {
  return {
    ...state,
    information: {
      isLoading: true,
      isLoaded: !state.information ? false : !!state.information.isLoaded,
      hasError: false,
    },
  }
}

reducers[FETCH_BILLING_INFORMATION_SUCCESS] = (state, action) => {
  const data = action.payload.data
  const { billingInformation } = data

  return {
    ...state,
    information: {
      isLoading: false,
      isLoaded: true,
      data: billingInformation,
    },
  }
}

reducers[UPDATE_BILLING_INFORMATION_SUCCESS] = (state, action) => {
  const { updateBillingInformation } = action.payload

  return {
    ...state,
    information: {
      data: updateBillingInformation,
    },
  }
}

reducers[FETCH_BILLING_INFORMATION_FAILED] = (state, action) => {
  const error = action.payload.error

  return {
    ...state,
    information: {
      isLoading: false,
      hasError: true,
      error,
    },
  }
}

reducers[CLOSE_CARD_FAILURE_MODAL] = state => {
  return {
    ...state,
    showCardErrorModal: false,
  }
}

reducers[SAVE_CANNED_REPLY_TEMPLATE_SUCCESS] = state => {
  if (state.usage.inbox.cannedReplies > 0) return state

  return {
    ...state,
    usage: {
      ...state.usage,
      inbox: {
        ...state.usage.inbox,
        cannedReplies: 1,
      },
    },
  }
}

// We only want to update the cannedReplies usage in state if we're loading canned replies
// for a completely unflitered state.
const FILTER_KEYS = ['category', 'keywords', 'categoryIds']

reducers[FETCH_CANNED_REPLIES_SUCCESS] = (state, action) => {
  const {
    request: { parameters = {} } = {},
    payload: {
      meta: { pagination: { total_count: cannedReplies } = {} } = {},
    } = {},
  } = action

  const keys = Object.keys(parameters)
  if (FILTER_KEYS.some(k => keys.includes(k))) return state
  if (cannedReplies === undefined) return state

  return {
    ...state,
    usage: {
      ...state.usage,
      inbox: {
        ...state.usage.inbox,
        cannedReplies,
      },
    },
  }
}

reducers[UPDATE_BILLING_INFORMATION_FAILED] =
  reducers[FETCH_BILLING_INFORMATION_FAILED]

export default function reducer(state = {}, action) {
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
